export const version = '3.2.0'
export const name = 'js-libp2p'
